import React, { useState, useMemo } from "react";
import { Dropdown, Modal, message as toast, Popover, Tabs, Menu } from "antd";
import IconFont from "@/components/icon";
import { Avatar } from "@/baseComponents/Avatar";
import { getThumbUrl } from "@/utils/chat/index";
import "./GroupNoticeItem.less";
import bus from "@/utils/bus";
import { changeEgovUrl } from "@/utils/tools";
import CopyClipboard from "copy-to-clipboard";
import ComGroupAlias from "@/baseComponents/ComGroupAlias";
import { UserCardPayload } from "@/models";
import { UserCardType } from "@/types/UserCard";
import { getUnitTitleInfo } from "@/utils/chat/message";
import noDataPicture from "@/assets/img/userlist-empty.png";
import { findAnnouncementDetail } from "../../api";
import ImService from "@/server/ImService";

const { TabPane } = Tabs;

interface IAnnounceDetail {
  announcementId: string;
  senderUserId: string;
  senderTeamId: string;
  senderUserAppId: string;
  senderUserName: string;
  senderUserAvatar: string;
  content: string;
  receiverSize: number;
  ackSize: number;
  pubTime: number;
  acked: boolean;
  showType: number;
  attachmentUrl: string[];
  userNum: number;
  users: {
    userId: string;
    teamId: string;
    app: string;
    userRole: number;
    duty: string;
    userName: string;
    headImg: string;
    acked: boolean;
    fullName: string;
  }[];
}

function GroupNoticeItem(props: any) {
  const { item, t, level, session, toggleUserCardModal, projectId, updateList } = props;
  const unReadNum = (item.userNum || 0) - (item.ackSize || 0); // 未读条数
  const text = unReadNum ? "未读" : "全部已读";
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [detailData, setDetailData] = useState<IAnnounceDetail>();
  const [isvisible, setIsvisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  // 复制  cxz
  function doCopy(e: any) {
    e.stopPropagation();
    if (item.content) {
      let userSelection;
      let str = item.content;
      if (typeof window.getSelection === "function") {
        userSelection = window.getSelection();
      }
      if (userSelection?.toString()) {
        str = userSelection.toString();
      }
      if ((str || "").length > (item.content || "").length) {
        str = item.content;
      }
      if (str && CopyClipboard(str)) {
        toast.success("复制成功");
      } else {
        toast.error("复制失败");
      }
    }
  }

  const handleAckSizeClick = (e: any) => {
    e.stopPropagation();
    getDetail(item.announcementId);
  };

  const getDetail = async function (announcementId: string) {
    setLoading(true);
    const imService = ImService.getInstance();
    const res = await findAnnouncementDetail(projectId, announcementId, "Group_Announcement");
    const rosters = await imService.getGroupRosterInfo(projectId, true);
    // const rosters = (session?.info as any).rosters;
    // const data = rosters ? Object.values(rosters) : [];
    setLoading(false);
    if (res.errCode) {
      // 如果公告删除直接关闭公告详情页面
      bus.emit("groupNoticeList:updata", {
        projectId,
        announcementId: announcementId
      });
      return;
    }

    // eslint-disable-next-line array-callback-return
    res.announcementDetailInfo.users = res.announcementDetailInfo.users.map((item: any) => {
      let newDetailData: any;
      rosters.map((item1: any) => {
        if (item.userId === item1.info?.userId) {
          newDetailData = {
            ...item,
            unitName: item1.info?.unitName,
            titleName: item1.info?.titleName
          };
        }
        return newDetailData;
      });
      return newDetailData;
    });
    setDetailData(res.announcementDetailInfo);
    updateList(res.announcementDetailInfo);
    // if (!res.announcementDetailInfo.acked) {
    //   ackAnnouncement(projectId, announcementId, "Group_Announcement");
    // }
    setIsvisible(true);
  };

  const handleShowUserCard = (e: any) => {
    e.stopPropagation();
    bus.emit("app:toggle-user-card-modal:show", {
      visible: true,
      type: UserCardType.User,
      userId: item.senderUserId,
      teamId: item.senderTeamId,
      appId: item.senderUserAppId
    });
  };

  const tabTitles = [
    `${t("detail.announce.no_read")} ${(detailData?.userNum || 0) - (detailData?.ackSize || 0)}`,
    `${t("detail.announce.has_read")} ${detailData?.ackSize || 0}`
  ];

  const ackUserContent = (
    <Tabs defaultActiveKey="0" tabBarGutter={90} onClick={(e) => e.stopPropagation()}>
      {tabTitles.map((tabItem, index) => {
        const userData =
          (detailData?.users || []).filter((item) => {
            return index === 0 ? !item.acked : item.acked;
          }) || [];
        if (userData.length === 0) {
          return (
            <TabPane tab={tabItem} key={index}>
              <div className="pm-announce-nodata-img">
                <img src={changeEgovUrl(noDataPicture)} alt="" />
                <p>{t("detail.no_data")}</p>
              </div>
            </TabPane>
          );
        }
        return (
          <TabPane tab={tabItem} key={index}>
            <ul className="pm-detail-user-list">
              {userData.map((item: any) => {
                return (
                  <li key={item.app + item.userId + item.teamId} style={{ padding: "8px 16px" }}>
                    {/* {item.headImg ? (
                                        <img src={changeEgovUrl(getThumbUrl(item.headImg, 30, 30))} alt="" />
                                    ) : (
                                        <span>{item.userName[0]}</span>
                                        )} */}
                    <span>
                      <Avatar
                        src={changeEgovUrl(getThumbUrl(item.headImg, 30, 30))}
                        styleObj={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "6px",
                          fontSize: "11px"
                        }}
                        name={item.userName || ""}
                      />
                    </span>
                    <div className="name-alias">
                      <h6 className="ellipsis">{item.userName}</h6>
                      <ComGroupAlias
                        user={{
                          ...item,
                          app: item.app || (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || ""
                        }}
                        session={session as any}
                      />
                    </div>
                    <p>{getUnitTitleInfo(item?.unitName, item?.titleName)}</p>
                  </li>
                );
              })}
            </ul>
          </TabPane>
        );
      })}
    </Tabs>
  );

  function visibleChange(visible: boolean) {
    setIsvisible(visible);
  }

  const DropDownMenu = useMemo(() => {
    return (
      <Menu selectedKeys={[""]}>
        <Menu.Item
          onClick={({ domEvent }) => {
            domEvent.stopPropagation();

            bus.emit("editGroupNotice:updata", {
              content: item?.content || "",
              announcementId: item?.announcementId || ""
            });
          }}
        >
          <IconFont type="iconjs_ic_edit" className="pm-announce-small-icon" />
          编辑
        </Menu.Item>
        <Menu.Item
          onClick={({ domEvent }) => {
            domEvent.stopPropagation();
            showModal();
          }}
        >
          <IconFont type="icondelect" />
          删除
        </Menu.Item>
      </Menu>
    );
  }, [item.announcementId, item.content]);

  return (
    <div className="group-notice-item newItem">
      <div className="header">
        <Avatar
          src={changeEgovUrl(getThumbUrl(item.senderUserAvatar, 26, 26))}
          styleObj={{
            width: "36px",
            height: "36px",
            borderRadius: "6px"
          }}
          name={item.senderUserName}
          onClick={handleShowUserCard}
        />
        <div className="title_name">
          <div className="name-header">
            <div className="name-alias">
              <span className="ellipsis">{item.senderUserName}</span>
              <ComGroupAlias
                user={{
                  app: item.senderUserAppId,
                  teamId: item.senderTeamId,
                  userId: item.senderUserId
                }}
                session={session}
              />
            </div>
            {(level === 1 || level === 2) && (
              <Dropdown
                overlayClassName="group-announcement-contextMenu"
                getPopupContainer={(trigger) => {
                  return (trigger?.parentNode || document.body) as HTMLElement;
                }}
                overlay={DropDownMenu}
                trigger={["hover"]}
              >
                <IconFont
                  type="iconlog_more"
                  className="log_more"
                  onClick={(e) => e.stopPropagation()}
                />
              </Dropdown>
            )}
          </div>
          <div className="acksize-right">
            <span>更新于{item.pubTime}</span>
          </div>
        </div>
      </div>
      <Dropdown
        overlayClassName="group-announcement-contextMenu"
        overlay={() => {
          return (
            <div
              className="paste-space"
              onClick={(e) => {
                doCopy(e);
              }}
            >
              复制
            </div>
          );
        }}
        trigger={["contextMenu"]}
      >
        <div className="content content-h-80">
          <p>{item.content}</p>
        </div>
      </Dropdown>
      <div className="footer">
        <Popover
          overlayClassName="detailData_Popover"
          content={ackUserContent}
          placement="bottomRight"
          trigger="click"
          onVisibleChange={visibleChange}
          visible={isvisible}
        >
          <span className="acksize-container" onClick={handleAckSizeClick}>
            {unReadNum ? `${text}：${unReadNum}/${item.userNum || 0}` : "全部已读"}
          </span>
        </Popover>
        <span className="detail-btn">
          查看详情 <IconFont type="iconjs_ilist_arrowright" className="detail-btn-icon" />
        </span>
      </div>
      {/* <div
        className="operation"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {(level === 1 || level === 2) && (
          <div
            style={{ marginRight: "24px" }}
            onClick={(e) => {
              e.stopPropagation();

              bus.emit("editGroupNotice:updata", {
                content: item?.content || "",
                announcementId: item?.announcementId || ""
              });
            }}
          >
            <IconFont type="iconjs_ic_edit" className="pm-announce-small-icon" />
            编辑
          </div>
        )}

        <div
          onClick={(e) => {
            doCopy(e);
          }}
        >
          <IconFont type="iconapp_btn_copy" />
          复制
        </div>
        {(level === 1 || level === 2) && (
          <div
            style={{ color: "#ff5e27", marginLeft: "24px" }}
            onClick={(e) => {
              e.stopPropagation();
              showModal();
            }}
          >
            <IconFont type="icondelect" />
            删除
          </div>
        )}
      </div> */}
      <div
        onClick={(e) => {
          e.stopPropagation();
          return;
        }}
      >
        <Modal
          title="提醒"
          className="removeModal"
          width={400}
          visible={isModalVisible}
          onOk={(e) => {
            e.stopPropagation();
            bus.emit("removeGroupNotice:updata", item.announcementId);
            setIsModalVisible(false);
          }}
          onCancel={(e) => {
            e.stopPropagation();
            setIsModalVisible(false);
          }}
          okText="确定"
          cancelText={t("cancel")}
          maskClosable={true}
          centered
        >
          <p style={{ textAlign: "center" }}>确认删除当前公告吗？</p>
        </Modal>
      </div>
    </div>
  );
}

export default GroupNoticeItem;
